const Component9 = ({ items, handleSelection, selectedCategory, selectedColor }) => {
  if (items.length !== 9) {
    return <div>Questo componente è progettato per 9 elementi!</div>;
  }

  const isOutOfStock = (item) => {
    const v = item?.out_of_stock;
    return v === 1 || v === true || v === "1" || v === "true";
  };

  const firstColumnItems = items.slice(0, 3);
  const secondColumnItem = items.slice(3, 6);
  const terzaColumnItem = items.slice(6, 9);

  const commonClass = (item) =>
    `grid-item
     ${selectedColor === item.id ? "selected-border" : ""}
     ${isOutOfStock(item) ? "disabled" : ""}
     ${item.id === "none" ? "grid-item-none" : ""}`.trim();

  const commonStyle = (item) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    height: "33.33%",
    color: "white",
    backgroundImage: `url("${item.bg}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: item?.id === "none" ? "60% auto" : "cover",
  });

  const handleClick = (item) => {
    if (isOutOfStock(item)) return;
    handleSelection(selectedCategory, item.id);
  };

  return (
    <div
      className="row m-0"
      style={{
        gap: "10px",
        width: "100%",
        height: "100%",
      }}
    >
      {/* Prima colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {firstColumnItems.map((item, index) => (
          <div
            key={`first-column-${index}`}
            onClick={() => handleClick(item)}
            className={commonClass(item)}
            style={commonStyle(item)}
          ></div>
        ))}
      </div>

      {/* Seconda colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {secondColumnItem.map((item, index) => (
          <div
            key={`second-column-${index}`}
            onClick={() => handleClick(item)}
            className={commonClass(item)}
            style={commonStyle(item)}
          ></div>
        ))}
      </div>

      {/* Terza colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {terzaColumnItem.map((item, index) => (
          <div
            key={`terza-column-${index}`}
            onClick={() => handleClick(item)}
            className={commonClass(item)}
            style={commonStyle(item)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Component9;
